var _path, _path2, _path3, _g, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 200.093H0V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 200.093z",
    fill: "#fab446"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V311.909h512v102.988a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#73af00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 200.091h512v111.81H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 303.449c-26.164 0-47.448-21.284-47.448-47.448s21.284-47.448 47.448-47.448 47.448 21.284 47.448 47.448-21.284 47.448-47.448 47.448zm0-86.069c-21.298 0-38.621 17.323-38.621 38.621 0 21.298 17.323 38.621 38.621 38.621s38.621-17.323 38.621-38.621c0-21.298-17.323-38.621-38.621-38.621z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256.001,
    r: 5.379
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 256.808l-13.67 1.38-29.364-1.38v-1.614l29.364-1.38 13.67 1.38zM256 256.808l13.67 1.38 29.364-1.38v-1.614l-29.364-1.38-13.67 1.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.193 256.001l-1.38-13.67 1.38-29.364h1.614l1.38 29.364-1.38 13.67zM255.193 256.001l-1.38 13.67 1.38 29.364h1.614l1.38-29.364-1.38-13.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.43 256.571l-10.642-8.689L225 226.142l1.141-1.141 21.74 19.788 8.689 10.642z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.43 256.571l8.689 10.642 21.74 19.788L287 285.86l-19.788-21.74-10.642-8.689z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.43 255.431l8.689-10.642 21.74-19.788 1.141 1.141-19.788 21.74-10.642 8.689zM255.43 255.431l-10.642 8.689L225 285.86l1.141 1.141 21.74-19.788 8.689-10.642z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.309 256.747l-12.102 6.506-27.656 9.962-.618-1.491 26.601-12.512 13.157-3.957z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.309 256.747l13.157-3.957 26.601-12.512-.618-1.491-27.656 9.962-12.102 6.506z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.254 256.31l-6.506-12.102-9.962-27.656 1.491-.618 12.512 26.601 3.957 13.157z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.254 256.31l3.957 13.157 12.512 26.601 1.491-.618-9.962-27.656-6.506-12.102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.691 256.747l-13.157-3.957-26.601-12.512.618-1.491 27.656 9.962 12.102 6.506zM255.691 256.747l12.102 6.506 27.656 9.962.618-1.491-26.601-12.512-13.157-3.957z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.254 255.692l3.957-13.157 12.512-26.601 1.491.618-9.962 27.656-6.506 12.102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.254 255.692l-6.506 12.102-9.962 27.656 1.491.618 12.512-26.601 3.957-13.157z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256.001,
    r: 7.256,
    fill: "#f5f5f5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256.001,
    r: 4.351,
    fill: "#41479b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.245fc3ccd80ff3dc3fa736d0f52d2004.svg";
export { ForwardRef as ReactComponent };